var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"21","height":"18","viewBox":"0 0 195 146","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M0 0H195V146H0V0Z","fill":"white"}}),_c('path',{attrs:{"d":"M0 53.0771H195V92.923H0V53.0771Z","fill":"#003580"}}),_c('path',{attrs:{"d":"M53.4726 0H93.3562V146H53.4421L53.4726 0Z","fill":"#003580"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }